import { useRef } from "react";
import { useInView } from "framer-motion";

export default function Video({ src }: {src:string}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    amount: 0.5,
  });

  return (
    <iframe
      ref={ref}
      className="w-full rounded-xl aspect-video border-solid border-gray border-[1px]"
      src={
        isInView
          ? `${src}?autoplay=1&mute=1&rel=0&modestbranding=1`
          : src
      }
      title="DIE ANDERE SEITE DER MUR"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    />
  );
}